import { ICountry } from '../../interfaces';

export const getLocaleFromCountry = (countries: ICountry[], shipCountry: string): string => {
  const currentCountry = countries.find((c) => c.countryCode === shipCountry);
  if (currentCountry) {
    return currentCountry.labels.locale;
  }
  return 'en-US';
};

export const getGDPRStatusFromCountry = (countries: ICountry[], shipCountry: string): boolean => {
  const currentCountry = countries.find((c) => c.countryCode === shipCountry);
  if (currentCountry) {
    return currentCountry.hasGdpr;
  }
  return false;
};
